(function () {
  if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') {
    return;
  }

  window.gsap.defaults({
    ease: window.Power4 ? window.Power4.easeOut : 'power4.out'
  });
  window.gsap.config({
    nullTargetWarn: false
  });
  window.gsap.registerPlugin(window.ScrollTrigger);
})();
